
import Vue from "vue";
import TableCustom from "@/components/TableCustom.vue";

export default Vue.extend({
  name: "VibrationSensorAlarmLimitHistoryDialog",
  components: { TableCustom },
  props: {
    equipmentModelId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
      loading: false,
      history: [] as any[],
      selectedSensorId: null as string | null,
      headers: [
        {
          text: "Date",
          value: "createdDate",
          width: "150px",
          style: { position: "sticky", left: "0px", zIndex: 3, background: "#fff" },
        },
        {
          text: "Sensor ID",
          value: "sensorId",
          width: "120px",
          style: { position: "sticky", left: "150px", zIndex: 3, background: "#fff" },
        },
        { text: 'Acc_X <span style="color:#fca239">Warn</span>', value: "accelerationXWarning" },
        { text: 'Acc_X <span style="color:#d9263b">Alarm</span>', value: "accelerationXAlarm" },
        { text: 'Acc_Y <span style="color:#fca239">Warn</span>', value: "accelerationYWarning" },
        { text: 'Acc_Y <span style="color:#d9263b">Alarm</span>', value: "accelerationYAlarm" },
        { text: 'Acc_Z <span style="color:#fca239">Warn</span>', value: "accelerationZWarning" },
        { text: 'Acc_Z <span style="color:#d9263b">Alarm</span>', value: "accelerationZAlarm" },
        { text: 'Vel_X <span style="color:#fca239">Warn</span>', value: "velocityXWarning" },
        { text: 'Vel_X <span style="color:#d9263b">Alarm</span>', value: "velocityXAlarm" },
        { text: 'Vel_Y <span style="color:#fca239">Warn</span>', value: "velocityYWarning" },
        { text: 'Vel_Y <span style="color:#d9263b">Alarm</span>', value: "velocityYAlarm" },
        { text: 'Vel_Z <span style="color:#fca239">Warn</span>', value: "velocityZWarning" },
        { text: 'Vel_Z <span style="color:#d9263b">Alarm</span>', value: "velocityZAlarm" },
        { text: 'Env_X <span style="color:#fca239">Warn</span>', value: "envelopeXWarning" },
        { text: 'Env_X <span style="color:#d9263b">Alarm</span>', value: "envelopeXAlarm" },
        { text: 'Env_Y <span style="color:#fca239">Warn</span>', value: "envelopeYWarning" },
        { text: 'Env_Y <span style="color:#d9263b">Alarm</span>', value: "envelopeYAlarm" },
        { text: 'Env_Z <span style="color:#fca239">Warn</span>', value: "envelopeZWarning" },
        { text: 'Env_Z <span style="color:#d9263b">Alarm</span>', value: "envelopeZAlarm" },
        { text: 'Temp <span style="color:#fca239">Warn</span>', value: "temperatureWarning" },
        { text: 'Temp <span style="color:#d9263b">Alarm</span>', value: "temperatureAlarm" },
      ],
    };
  },
  computed: {
    sensorIdOptions(): string[] {
      const ids = [...new Set((this as any).history.map((r: any) => r.sensorId).filter(Boolean))];
      return (ids as string[]).sort();
    },
    filteredHistory(): any[] {
      if (!(this as any).selectedSensorId) return (this as any).history;
      return (this as any).history.filter((r: any) => r.sensorId === (this as any).selectedSensorId);
    },
  },
  methods: {
    async fetchHistory() {
      this.loading = true;
      try {
        this.history = await (this as any).$dep.modelUseCase.getVibrationSensorAlarmLimitHistory(this.equipmentModelId);
      } catch (e) {
        this.history = [];
      } finally {
        this.loading = false;
      }
    },
    formatDate(dateStr: string): string {
      if (!dateStr) return "-";
      const d = new Date(dateStr);
      return (
        d.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" }) +
        ", " +
        d.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit", hour12: false })
      );
    },
  },
});
